export const ExtolePostMessageDescription = {
  IFRAME_HEIGHT: 'IFrame Height',
};
